import { render, staticRenderFns } from "./oc_pendiente_x_subcategoria_proveedor.vue?vue&type=template&id=1e9dda07&"
import script from "./oc_pendiente_x_subcategoria_proveedor.vue?vue&type=script&lang=js&"
export * from "./oc_pendiente_x_subcategoria_proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports